import { fromJS } from 'immutable';
import { SET_RULES } from './constants';
import { APP_RESET } from '../App/constants';

const initialState = fromJS({
  sections: [],
  pages: [],
  loaded: false,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_RULES:
      return state
        .set('sections', action.payload.get('sections'))
        .set('pages', action.payload.get('pages'))
        .set('loaded', true);

    case APP_RESET:
      return initialState;

    default:
      return state;
  }
}

export default reducer;
